import { SVGProps } from "react";

const Home = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.8386 3.51243L3.8386 4.29298C2.32193 5.47681 1.5636 6.06873 1.15686 6.90333C0.750122 7.73792 0.750122 8.70205 0.750122 10.6303V12.7215C0.750122 16.5062 0.750122 18.3985 1.92169 19.5743C3.09327 20.75 4.97889 20.75 8.75012 20.75H10.7501C14.5214 20.75 16.407 20.75 17.5785 19.5743C18.7501 18.3985 18.7501 16.5062 18.7501 12.7215V10.6303C18.7501 8.70205 18.7501 7.73792 18.3434 6.90333C17.9366 6.06873 17.1783 5.47681 15.6616 4.29298L14.6616 3.51243C12.3023 1.67081 11.1226 0.75 9.75012 0.75C8.37769 0.75 7.19799 1.67081 4.8386 3.51243Z"
      stroke="#626262"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <circle
      cx="9.75012"
      cy="14.25"
      r="2.5"
      stroke="#626262"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default Home;
